import { colors } from '@lmc/common/constants'
import type { Home, Resident } from '@lmc/ts-common'
import type * as React from 'react'

type PDFHeaderProps = {
  home?: Home
  resident?: Resident
  headingExtra?: string
}

export const PDFHeader = ({
  home,
  resident,
  headingExtra
}: PDFHeaderProps): React.ReactElement => (
  <div style={styles.wrapper}>
    <h2 style={styles.title}>
      <div>
        {resident?.name?.first} {resident?.name?.last} {headingExtra || ''}
      </div>
      <div>{home?.name}</div>
    </h2>
    <div style={styles.divider} />
  </div>
)

const styles = {
  divider: {
    background: colors.grey,
    height: 2,
    width: '100%'
  },
  title: {
    display: 'flex',
    flexGrow: 1,
    fontWeight: 300,
    justifyContent: 'space-between'
  },
  wrapper: {
    marginBottom: 36,
    width: '100%'
  }
}

export default PDFHeader
